module.exports = __webpack_public_path__ + "img/yilianGl8.0e91f3f6.png";